import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chart-line",
  "use": "icon-chart-line-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chart-line\"><path d=\"M85.504 938.688H1024V1024H0v-85.312h0.192V0h85.312v938.688z m120.256-169.984l-70.208-48.512L372.48 377.728l303.424 155.52 265.472-345.92 67.712 51.968-308.8 402.304-300.16-153.856-194.368 280.96z\" fill=\"#262626\" p-id=\"4423\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol